"use client";

import Breadcrumbs from "@/components/entities/breadcrumbs";
import HeaderBackground from "@/components/ui/header-background";
import CustomIcon from "@/components/ui/custom-icon";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const DetailActualHeader = () => {
  const router = useRouter();
  const t = useTranslations();

  const breadcrumbs = [
    { title: t("home"), url: "/" },
    { title: t("news"), url: "/actual" },
  ];

  return (
    <>
      <div className={S.backWrapper}>
        <HeaderBackground type="black" />
        <div className={S.linkWrapper}>
          <span className={S.backLink} onClick={() => router.back()}>
            <CustomIcon fileName="icon-arrow-right" /> {t("back")}
          </span>
        </div>
      </div>
      <Container className={S.wrapper}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </Container>
    </>
  );
};

export default DetailActualHeader;
